var report = false;
$(document).ready(function () {
	report = new cReports();
});

function cReports () {
	var self = this;
	// Only run on /pages/ page.
	if (window.location.href.indexOf('/reports') > -1) {
		this.onload();
	}
	$('.report-delete').click(function () {
		return confirm('Are you sure?');
	});
}

cReports.prototype.onload = function () {
	var self = this;
	$('#select-all').click(function () {
		var checkboxes = $(this).closest('form').find(':checkbox');
		checkboxes.prop('checked', $(this).is(':checked'));
	});
	$('#form-showfilelocation .btn').click(function () {
		id = $('#id').val();
		$('#form-showfilelocation').get(0).setAttribute('action', '/reports/' + id + '/filelocationreport');
		$('#form-showfilelocation').submit();
	});
	$('#form-itemshowstatus .btn').click(function () {
		id = $('#id').val();
		$('#form-itemshowstatus').get(0).setAttribute('action', '/reports/' + id + '/itemstatusreport');
		$('#form-itemshowstatus').submit();
	});
	$('#btn-save').click(function () {
		url = window.location.href;
		name = $('#txt-save-report').val();
		inputurl = '<input name="url" type="hidden" value="' + url + '">';
		inputname = '<input name="report_name" type="hidden" value="' + name + '">';
		csrf = $('[name="csrf-token"]').attr('content');
		$('<form action="/reports/store" method="post"><input name="_token" type="hidden" value="' + csrf + '">' + inputurl + inputname + '</form>').appendTo('body').submit();
	});
};
